// src/pages/BorrowItem.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useBorrowCart } from "../context/BorrowCartContext";

import { API_BASE_URL } from "../utils/config";

function BorrowItem() {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const { addItem } = useBorrowCart();

  const [item, setItem] = useState(null);
  const [loadingItem, setLoadingItem] = useState(true);
  const [itemError, setItemError] = useState("");

  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    async function fetchItem() {
      try {
        setLoadingItem(true);
        const res = await fetch(`${API_BASE_URL}/api/items/${itemId}/`);
        if (!res.ok) throw new Error("Failed to load item.");
        const data = await res.json();
        setItem(data);
      } catch (err) {
        console.error(err);
        setItemError("Failed to load item. Please try again.");
      } finally {
        setLoadingItem(false);
      }
    }
    fetchItem();
  }, [itemId]);

  const handleAddToCart = (e) => {
    e.preventDefault();

    const qty = Number(quantity);
    if (!qty || qty <= 0) return;

    addItem(
      {
        itemId: Number(itemId),
        code: item?.code || "",
        name: item?.name || "",
        unit: item?.unit || "",
      },
      qty
    );

    navigate("/cart");
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">Add to Borrow Cart</h1>

      {loadingItem && <p className="text-sm text-muted">Loading item…</p>}
      {itemError && <p className="text-sm text-red-600 mb-3">{itemError}</p>}

      {item && (
        <>
          <div className="glass-card p-4 mb-4">
            <p className="text-xs text-muted mb-1">Item</p>
            <p className="text-sm font-semibold">
              {item.code} — {item.name}
            </p>
          </div>

          <form
            onSubmit={handleAddToCart}
            className="glass-card p-4 max-w-md space-y-3"
          >
            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Quantity *
              </label>
              <input
                type="number"
                min={1}
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
              />
              <p className="text-[11px] text-muted mt-1">
                Return date + notes are entered once on the Cart page (batch-level).
              </p>
            </div>

            <div className="flex items-center gap-2 pt-2">
              <button
                type="submit"
                className="inline-flex items-center px-4 py-2 text-sm font-semibold rounded-md bg-brand-600 text-white hover:bg-brand-700"
              >
                Add to cart
              </button>

              <button
                type="button"
                onClick={() => navigate(-1)}
                className="inline-flex items-center px-3 py-2 text-xs font-semibold rounded-md border border-white/50 dark:border-white/15 text-strong hover:bg-brand-500/5"
              >
                Cancel
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
}

export default BorrowItem;
